export default __webpack_public_path__ + "static/media/imagen2.553809b8.jpg";